import React from "react";

const AddShipmentIconSvg = ({ stroke = "#a3a3a3", size = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <path
      d="M13.4726 9.99956H10.4726M10.4726 9.99956H7.47255M10.4726 9.99956V12.9996M10.4726 9.99956L10.4726 6.99956M18.4722 5L18.4722 15.0001C18.4722 16.6569 17.1291 18.0001 15.4722 18.0001H5.47223C3.81537 18.0001 2.47223 16.6569 2.47223 15.0001V5C2.47223 3.34315 3.81537 2 5.47223 2H15.4722C17.1291 2 18.4722 3.34315 18.4722 5Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default AddShipmentIconSvg;
